<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">Withdrawal Policy</h3>
    <div class="informationBox">
      <ul class="useragreement">
        <li>
          <div class="t1">Right of Withdrawal</div>
          <p>You have the right to withdraw within 14 days without giving reasons.</p>
          <p>The period begins:</p>
          <div class="t3">
            <ul class="agreementList">
              <li>from the day you receive the goods</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">Exercising Withdrawal</div>
          <p>Contact:</p>
          <p> </p>
          <p>Cardhobby Germany GmbH</p>
          <p>Luisenstraße 9</p>
          <p>40215 Düsseldorf</p>
          <p>Email: infode@cardhobby.com</p>
          <p>Phone: +49 17643383156</p>
        </li>
        <li>
          <div class="t1">Effects of Withdrawal</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Full refund including standard shipping</li>
              <li>Refund within 14 days</li>
              <li>Same payment method</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">Returns</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Goods must be returned within 14 days</li>
              <li>Customer bears return costs</li>
            </ul>
          </div>
        </li>
        
        <li>
          <div class="t1">Exclusions</div>
          <p>No withdrawal for:</p>
          <div class="t3">
            <ul class="agreementList">
              <li>opened sealed goods </li>
              <li>opened trading cards</li>
              <li>custom-made products</li>
            </ul>
          </div>
        </li>
        <li><a :href="$interface.downloadWord">Withdrawal Form</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
    }
  },
  mounted() {},
  created() {
    this.closeDialog()
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dislogType.login = false
      this.dislogType.register = false
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
@import "../../../static/css/information.css";
.agreementList li{
  list-style: inside;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/withdrawalagreement.vue